/**
 * 参画施設詳細（list）スライダー - Embla Carousel
 * .list-embla が存在するときのみ初期化
 */

import EmblaCarousel from "embla-carousel";

const LIST_EMBLA_SELECTOR = ".list-embla";
const VIEWPORT_SELECTOR = ".list-embla__viewport";
const PREV_SELECTOR = ".list-embla__prev";
const NEXT_SELECTOR = ".list-embla__next";
const DOTS_SELECTOR = ".list-embla__dots";
const THUMBS_SELECTOR = ".list-embla__thumbs";
const THUMB_SELECTOR = ".list-embla__thumb";

function setupPrevNext(embla, root) {
	const prevBtn = root.querySelector(PREV_SELECTOR);
	const nextBtn = root.querySelector(NEXT_SELECTOR);
	if (!prevBtn || !nextBtn) return;

	const updateButtons = () => {
		prevBtn.disabled = !embla.canScrollPrev();
		nextBtn.disabled = !embla.canScrollNext();
	};
	embla.on("select", updateButtons);
	updateButtons();

	prevBtn.addEventListener("click", () => embla.scrollPrev());
	nextBtn.addEventListener("click", () => embla.scrollNext());
}

function setupDots(embla, root) {
	const dotsEl = root.querySelector(DOTS_SELECTOR);
	if (!dotsEl) return;

	const slides = embla.slideNodes();
	slides.forEach((_, i) => {
		const btn = document.createElement("button");
		btn.type = "button";
		btn.setAttribute("aria-label", `スライド ${i + 1} へ`);
		btn.classList.add("list-embla__dot");
		if (i === 0) btn.classList.add("is-active");
		btn.addEventListener("click", () => embla.scrollTo(i));
		dotsEl.appendChild(btn);
	});

	const updateDots = () => {
		const index = embla.selectedScrollSnap();
		const dots = dotsEl.querySelectorAll(".list-embla__dot");
		dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
	};
	embla.on("select", updateDots);
}

function setupThumbs(embla, root) {
	const thumbsRoot = root.querySelector(THUMBS_SELECTOR);
	if (!thumbsRoot) return;

	const thumbs = thumbsRoot.querySelectorAll(THUMB_SELECTOR);
	if (!thumbs.length) return;

	thumbs.forEach((thumb, index) => {
		thumb.addEventListener("click", () => embla.scrollTo(index));
	});

	const updateThumbs = () => {
		const index = embla.selectedScrollSnap();
		thumbs.forEach((thumb, i) => {
			thumb.classList.toggle("is-active", i === index);
		});
	};

	embla.on("select", updateThumbs);
	updateThumbs();
}

function initListEmbla() {
	const root = document.querySelector(LIST_EMBLA_SELECTOR);
	if (!root) return;

	const viewport = root.querySelector(VIEWPORT_SELECTOR);
	if (!viewport) return;

	const slideCount = viewport.querySelectorAll(".list-embla__slide").length;
	if (slideCount <= 1) return;

	const embla = EmblaCarousel(viewport, {
		align: "start",
		loop: false,
		draggable: true,
	});

	setupPrevNext(embla, root);
	setupDots(embla, root);
	setupThumbs(embla, root);
}

export function setListEmbla() {
	initListEmbla();
}
